import { View, XStack, YStack } from "tamagui";
import { Bar } from "./Bar";
import { FrontCard } from "./FrontCard";
const ROW_HEIGHT = 16;
const LINES = [52, undefined, 72, undefined, undefined, 52];

// Document card: the family's front card alone, upright and centred, with lines of text.
export const DocumentGraphic = () => <View width={160} height={160} position="relative" data-sentry-element="View" data-sentry-component="DocumentGraphic" data-sentry-source-file="DocumentGraphic.tsx">
    <FrontCard top={10} left={20} data-sentry-element="FrontCard" data-sentry-source-file="DocumentGraphic.tsx">
      <YStack width="100%" gap="$sp0.5" data-sentry-element="YStack" data-sentry-source-file="DocumentGraphic.tsx">
        {LINES.map((width, index) => <XStack key={index} width="100%" height={ROW_HEIGHT} alignItems="center">
            {width ? <Bar width={width} /> : <Bar flex />}
          </XStack>)}
      </YStack>
    </FrontCard>
  </View>;